export default __webpack_public_path__ + "static/media/Icons__trash2.8dc1db30.svg";